import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DollarIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Dollar`} {...props}>
    <Path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 3H6.5A2.5 2.5 0 0 0 4 5.5v0A2.5 2.5 0 0 0 6.5 8h3a2.5 2.5 0 0 1 2.5 2.5v0A2.5 2.5 0 0 1 9.5 13H4M8 1v14"
    />
  </Icon>
);
